
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./kaspi-pay.cjs.production.min.js')
} else {
  module.exports = require('./kaspi-pay.cjs.development.js')
}
